import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoOnboardingGuard } from './core/auth/guards/noOnboarding.guard';
import { OnboardingGuard } from './core/auth/guards/onboarding.guard';
import { RoleGuard } from './core/auth/guards/role.guard';
import { Role } from './core/user/user.types';

export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/common/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/common/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/common/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/common/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/common/auth/sign-up/sign-up.routes'),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/common/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/common/auth/unlock-session/unlock-session.routes'
                    ),
            },
        ],
    },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        loadChildren: () => import('app/modules/public/public.routes'),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canMatch: [RoleGuard([Role.Admin])],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'classy',
        },
        resolve: {
            data: initialDataResolver,
        },
        loadChildren: () => import('app/modules/admin/admin.routes'),
    },

    {
        path: 'onboarding',
        canActivate: [AuthGuard],
        canMatch: [RoleGuard([Role.OrganizationMember])],
        canActivateChild: [AuthGuard, NoOnboardingGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        resolve: {
            data: initialDataResolver,
        },
        loadChildren: () =>
            import('app/modules/corporation/onboarding/onboarding.routes'),
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canMatch: [RoleGuard([Role.OrganizationMember])],
        canActivateChild: [AuthGuard, OnboardingGuard],
        component: LayoutComponent,
        data: {
            layout: 'classy',
        },
        resolve: {
            data: initialDataResolver,
        },
        loadChildren: () =>
            import('app/modules/corporation/corporation.routes'),
    },

    { path: '**', redirectTo: '' },
];
